import React, { useState } from "react";
import Header from "./Header";
import Sidebar from "./Sidebar";
import Footer from "./Footer";
import PageLoader from "./PageLoader";
import { Outlet } from "react-router-dom";

const AdminLayout = () => {
    const [loading, setLoading] = useState(false);
    const [isOpen, setIsOpen] = useState(true);

    return (
        <>
            <style>{`
        .admin-app {
          display: flex;
        }

        .admin-main {
          margin-left: ${isOpen ? "220px" : "70px"};  
          flex: 1;
          display: flex;
          flex-direction: column;
          min-height: 100vh;
          background: #f3f3f4;
          transition: all 0.3s ease;
        }

        .admin-content {
          flex: 1;
          padding: 20px;
        }
      `}</style>

            <div className="admin-app">
                {/* ✅ Pass state */}
                <Sidebar isOpen={isOpen} />

                <div className="admin-main">
                    {/* ✅ Pass toggle function */}
                    <Header toggleSidebar={() => setIsOpen(!isOpen)} />

                    <div className="admin-content">
                        {loading && <PageLoader />}
                        <Outlet context={{ setLoading }} />
                    </div>

                    <Footer />
                </div>
            </div>
        </>
    );
};

export default AdminLayout;